module.exports = __webpack_public_path__ + "static/media/r_dot_13.88594c86.png";